var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSolarBackgroundCover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 525,
    height: 359,
    viewBox: "0 0 525 359",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M334.366 242.799L258.328 -76.1467C234.266 -68.2588 211.358 -58.4847 189.798 -46.8243L334.559 242.628L334.366 242.799Z",
    fill: "white",
    fillOpacity: 0.53
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M518.408 -78.719L441.6 242.799L588.285 -50.5969C566.34 -61.9143 542.855 -71.3455 518.408 -78.719Z",
    fill: "white",
    fillOpacity: 0.53
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M406.168 235.769L483.168 -87.8071C458.336 -93.1229 432.541 -96.2095 406.168 -96.8954V235.769Z",
    fill: "white",
    fillOpacity: 0.53
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M369.796 -96.5524C343.423 -95.1806 317.821 -91.5796 293.181 -85.7494L369.796 235.769V-96.5524Z",
    fill: "white",
    fillOpacity: 0.53
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M247.556 298.873L28.2975 122.938C20.5974 140.086 14.4374 158.091 9.81738 176.439L247.556 298.873Z",
    fill: "white",
    fillOpacity: 0.53
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M229.841 326.994L3.2674 210.391C1.53489 223.937 0.379883 237.655 0.379883 251.716V260.462L229.841 326.823V326.994Z",
    fill: "white",
    fillOpacity: 0.53
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M80.839 40.4576C66.9789 56.5764 54.6589 73.724 44.0713 92.072L271.993 274.866L80.839 40.4576Z",
    fill: "white",
    fillOpacity: 0.53
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M218.099 357.345L0.379883 294.413V337.11L218.099 357.345Z",
    fill: "white",
    fillOpacity: 0.53
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M301.063 255.832L159.19 -28.4755C139.555 -15.4433 121.459 -1.03926 104.904 14.908L301.255 255.661L301.063 255.832Z",
    fill: "white",
    fillOpacity: 0.53
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M474.91 255.832L675.111 10.1065C657.979 -5.84083 639.306 -20.0734 619.094 -32.9341L474.91 255.832Z",
    fill: "white",
    fillOpacity: 0.53
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M503.965 274.695L738.046 86.9281C726.881 68.5802 713.984 51.2611 699.546 34.9708L503.965 274.695Z",
    fill: "white",
    fillOpacity: 0.53
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolarBackgroundCover);
export default __webpack_public_path__ + "static/media/solar-background-cover.fb288bc7a6ac37453c7f13189567b203.svg";
export { ForwardRef as ReactComponent };